import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useKarsilastirma } from "../data/karsilastirma";

/** Ürünü karşılaştırma listesine ekler/çıkarır. "kucuk": kart üstü rozet, değilse tam düğme. */
export default function KarsilastirButonu({ id, kucuk = false }) {
  const { t } = useTranslation();
  const { icinde, degistir } = useKarsilastirma();
  const [uyari, setUyari] = useState(false);
  const secili = icinde(id);

  const tikla = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!degistir(id)) {
      setUyari(true);
      setTimeout(() => setUyari(false), 2200);
    }
  };

  const etiket = uyari ? t("compare.full") : secili ? t("compare.added") : t("compare.add");

  if (kucuk) {
    return (
      <button
        type="button"
        onClick={tikla}
        aria-pressed={secili}
        title={etiket}
        className={`absolute start-2.5 top-2.5 z-10 flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11.5px] font-medium shadow-sm backdrop-blur transition-all ${
          secili
            ? "border-ink bg-ink text-white"
            : "border-line bg-white/90 text-body opacity-100 hover:border-ink/40 hover:text-ink lg:opacity-0 lg:group-hover:opacity-100 lg:focus-visible:opacity-100"
        } ${uyari ? "!border-accent !bg-accent !text-white !opacity-100" : ""}`}
      >
        <span aria-hidden="true">{secili ? "✓" : "⇄"}</span>
        {etiket}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={tikla}
      aria-pressed={secili}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[12.5px] transition-colors ${
        secili ? "border-ink bg-ink text-white" : "border-line text-body hover:border-ink/30 hover:text-ink"
      } ${uyari ? "!border-accent !bg-accent !text-white" : ""}`}
    >
      <span aria-hidden="true">{secili ? "✓" : "⇄"}</span>
      {etiket}
    </button>
  );
}
